export type WorkspaceRouteDefinition = {
  id: string;
  legacyIds?: readonly string[];
};

function normalizeWorkspaceHash(hash: string): string {
  return hash.trim().replace(/^#/u, "");
}

export function resolveWorkspaceRouteId(
  hash: string,
  routes: readonly WorkspaceRouteDefinition[],
): string {
  if (routes.length === 0) {
    throw new Error("At least one workspace route is required.");
  }
  const fallbackRoute = routes[0];
  if (!fallbackRoute) {
    throw new Error("At least one workspace route is required.");
  }

  const normalized = normalizeWorkspaceHash(hash);
  const directMatch = routes.find((route) => route.id === normalized);
  if (directMatch) {
    return directMatch.id;
  }

  const legacyMatch = routes.find((route) => route.legacyIds?.includes(normalized));
  if (legacyMatch) {
    return legacyMatch.id;
  }

  return fallbackRoute.id;
}
